import { FC } from 'react';

import { GetStartedMicrocopyProps } from 'src/checkout/sections/GetStarted/GetStarted';
import { BaseCarData } from 'src/types/Car.types';
import GetStartedCarDetails from './GetStartedCarDetails';
import styles from './GetStartedCarTile.module.scss';
import GetStartedUsp from './GetStartedUsp';

interface GetStartedCarTileProps {
  carData: BaseCarData;
  microcopy: GetStartedMicrocopyProps;
  onOpen: () => void;
}

export const GetStartedCarTile: FC<GetStartedCarTileProps> = ({ carData, microcopy, onOpen }) => {
  return (
    <div className={styles.carDetailsContainer}>
      <GetStartedCarDetails {...carData} />
      <GetStartedUsp microcopy={microcopy} price={carData.price} onOpen={onOpen} />
    </div>
  );
};
